import React from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import { useParams } from 'next/navigation';
import { localeMapping } from 'helpers/constants/localeMapping';

export interface FooterLink {
  title: string;
  href: string;
}

export interface Props {
  header?: string;
  links: FooterLink[];
  className?: string;
}

const Column: React.FC<Props> = ({ header, links, className }) => {
  
  //Based on locale we are changing the CSS.  because in AU there are 5 columns and in NZ there are 4 columns
  const { locale } = useParams();
  const localeKey = localeMapping[locale];
  const textClass = localeKey === 'en-NZ' ? 'mt-2 text-15 font-normal hover:text-white md:text-15 3xl:text-15 mr-10' : 'mt-2 text-14 font-normal hover:text-white md:text-12 3xl:text-14 mr-10';
  
  return (
    <div className={className}>
      {header && (
        <Typography className="w-10/12 3xl:w-3/4 self-start border-b text-18 font-medium text-neutral-200 sm:pb-8 md:text-14 3xl:text-18">
          {header}
        </Typography>
      )}
      <ul
        role="list"
        className={`mb-3 flex flex-col items-start ${links.length > 5 ? '' : ''}  mt-10 gap-y-10 self-start`}
      >
        {links.map((item, i) => (
          <li key={i} className="inline-block">
            <Link variant="primary" link={item.href} target={item?.href?.includes("https://") ? '_blank' : ''}>
              <Typography className={`${textClass} inline-block`}>
                {item.title}
              </Typography>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Column;
